/* DistroHub — WebGL crate stage.
   Loaded only by sections that render <div id="stage">. Self-contained:
   it owns its own scroll + pointer listeners so it can be dropped without
   touching distrohub.js. */
(function () {
  "use strict";

  var stage = document.getElementById('stage');
  if (!stage || typeof THREE === 'undefined') return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  var scene, camera, renderer, crateGroup, particles;
  var mouse = { x: 0, y: 0, tx: 0, ty: 0 };
  var scrollP = 0;

  function scrollProgress() {
    var max = document.documentElement.scrollHeight - innerHeight;
    return max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
  }

  function init() {
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.6));
    renderer.setSize(innerWidth, innerHeight);
    stage.appendChild(renderer.domElement);

    scene = new THREE.Scene();
    scene.fog = new THREE.FogExp2(0x212529, 0.04);

    camera = new THREE.PerspectiveCamera(42, innerWidth / innerHeight, 0.1, 100);
    camera.position.set(0, 0.4, 13);

    /* lighting — cool key, warm-white rim, one blue accent */
    scene.add(new THREE.AmbientLight(0x454c53, 1.8));
    var keyLight = new THREE.DirectionalLight(0xe8edf3, 1.35);
    keyLight.position.set(6, 9, 6);
    scene.add(keyLight);
    var rim = new THREE.DirectionalLight(0x9fb2c8, 0.5);
    rim.position.set(-7, 3, -6);
    scene.add(rim);
    var accentLight = new THREE.PointLight(0x4f8fd4, 1.6, 22, 2);
    accentLight.position.set(-3.5, -1.5, 4);
    scene.add(accentLight);

    /* floating crates — matte graphite with subtle edge accents */
    crateGroup = new THREE.Group();
    var bodyMat = new THREE.MeshStandardMaterial({ color: 0x353c42, roughness: 0.42, metalness: 0.55 });
    var glassMat = new THREE.MeshPhysicalMaterial({ color: 0x3e474e, roughness: 0.15, metalness: 0.1, transparent: true, opacity: 0.55 });
    var edgeMat = new THREE.LineBasicMaterial({ color: 0x707b85, transparent: true, opacity: 0.65 });
    var geo = new THREE.BoxGeometry(1, 1, 1);
    var edgeGeo = new THREE.EdgesGeometry(geo);

    var count = innerWidth < 760 ? 16 : 26;
    for (var i = 0; i < count; i++) {
      var glass = Math.random() < 0.28;
      var m = new THREE.Mesh(geo, glass ? glassMat : bodyMat);
      var s = 0.5 + Math.random() * 1.5;
      m.scale.set(s, s * (0.6 + Math.random() * 0.8), s);
      m.position.set((Math.random() - 0.5) * 17, (Math.random() - 0.5) * 9, (Math.random() - 0.5) * 9 - 2);
      m.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * 0.4);
      m.userData = {
        spin: (Math.random() - 0.5) * 0.0016,
        spinY: (Math.random() - 0.5) * 0.0022,
        bobA: 0.12 + Math.random() * 0.3,
        bobS: 0.2 + Math.random() * 0.35,
        phase: Math.random() * Math.PI * 2,
        y0: m.position.y
      };
      m.add(new THREE.LineSegments(edgeGeo, edgeMat));
      crateGroup.add(m);
    }
    scene.add(crateGroup);

    /* particles — slow drifting dust */
    var pCount = innerWidth < 760 ? 260 : 520;
    var pos = new Float32Array(pCount * 3);
    for (var p = 0; p < pCount; p++) {
      pos[p * 3] = (Math.random() - 0.5) * 26;
      pos[p * 3 + 1] = (Math.random() - 0.5) * 16;
      pos[p * 3 + 2] = (Math.random() - 0.5) * 14;
    }
    var pGeo = new THREE.BufferGeometry();
    pGeo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    particles = new THREE.Points(pGeo, new THREE.PointsMaterial({
      color: 0x9ba4ac, size: 0.028, transparent: true, opacity: 0.6, sizeAttenuation: true
    }));
    scene.add(particles);

    window.addEventListener('resize', function () {
      camera.aspect = innerWidth / innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(innerWidth, innerHeight);
    });

    window.addEventListener('scroll', function () { scrollP = scrollProgress(); }, { passive: true });

    if (fine) {
      window.addEventListener('mousemove', function (e) {
        mouse.tx = (e.clientX / innerWidth - 0.5) * 2;
        mouse.ty = -(e.clientY / innerHeight - 0.5) * 2;
      }, { passive: true });
    }

    var running = true;
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) render();
    });

    var clock = new THREE.Clock();

    function render() {
      if (!running) return;
      requestAnimationFrame(render);
      var t = clock.getElapsedTime();

      if (!reduced) {
        crateGroup.children.forEach(function (m) {
          var u = m.userData;
          m.rotation.x += u.spin;
          m.rotation.y += u.spinY;
          m.position.y = u.y0 + Math.sin(t * u.bobS + u.phase) * u.bobA;
        });
        crateGroup.rotation.y = t * 0.018 + scrollP * 0.9;
        particles.rotation.y = t * 0.008;

        mouse.x += (mouse.tx - mouse.x) * 0.04;
        mouse.y += (mouse.ty - mouse.y) * 0.04;
        camera.position.x = mouse.x * 0.7;
        camera.position.y = 0.4 + mouse.y * 0.4 - scrollP * 2.2;
        camera.position.z = 13 - scrollP * 1.6;
        camera.lookAt(0, -scrollP * 2.2, 0);
      }
      renderer.render(scene, camera);
    }

    render();
  }

  try {
    init();
  } catch (e) {
    /* No WebGL (old device, blocked context) — the page reads fine without it. */
    stage.remove();
    if (window.console) console.warn('DistroHub stage: WebGL unavailable', e);
  }
})();
